
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/flagshipTerminal",
      function () {
        return require("private-next-pages/hardware/flagshipTerminal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/flagshipTerminal"])
      });
    }
  